"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _TwilioWhatsapp = /*#__PURE__*/ _interop_require_default(require("./TwilioWhatsapp"));
const _ncplugin = require("~/types/nc-plugin");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let TwilioWhatsappPlugin = class TwilioWhatsappPlugin extends _ncplugin.XcWebhookNotificationPlugin {
    getAdapter() {
        return TwilioWhatsappPlugin.notificationAdapter;
    }
    async init(config) {
        TwilioWhatsappPlugin.notificationAdapter = new _TwilioWhatsapp.default(config);
        await TwilioWhatsappPlugin.notificationAdapter.init();
    }
};
const _default = TwilioWhatsappPlugin;
